import { fromEvent, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import Orientations from '../entities/device-orientation.entity';

const Events = {
  ROTATE: 'change',
};

interface DeviceOrientation {
  rotation: DeviceOrientationValue | null;
}

type DeviceOrientationValue =
  | typeof Orientations.LANDSCAPE
  | typeof Orientations.PORTRAIT;

function properties(): DeviceOrientation {
  return {
    rotation: null,
  };
}

function calcOrientation() {
  const props = properties();

  props.rotation =
    screen.orientation.angle === 90 || screen.orientation.angle === -90
      ? Orientations.LANDSCAPE
      : Orientations.PORTRAIT;

  return props;
}

function registerOrientationChangeEvent(): Observable<DeviceOrientation> {
  return fromEvent(screen.orientation, Events.ROTATE).pipe(
    map(() => calcOrientation())
  );
}

const DeviceOrientationService = {
  orientationEvent: registerOrientationChangeEvent(),
  getOrientations() {
    return Orientations;
  },
};

export default DeviceOrientationService;
export { DeviceOrientation };
